/**
 * checkbox-list.js
 */

import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';


export default function CheckboxList(props) {
  const {
    formContext: formContextProp,
    name,
    rules,
    options,
    defaultValue,
  } = props;
  const formContextDefault = useFormContext();
  const formContext = formContextProp || formContextDefault;


  const getOptionChecked = ((option, checkList) => {
    return checkList.includes(option.value);
  });
    

  const setOptionChecked = ((option, checkList, isChecked) => {
    return isChecked
      ? [...checkList, option.value]
      : checkList.filter(i => i !== option.value);
  });


  if (!options) return null;


  return (
    <>
      <Controller
        control={formContext.control}
        name={name}
        rules={rules}
        defaultValue={defaultValue || []}
        render={({ field: { ref, ...inputProps } }) => (
          <>
            {options.map(option =>
              <div key={option.id}>
                <input 
                  type='checkbox' 
                  id={option.id} 
                  checked={getOptionChecked(option, inputProps.value || [])} 
                  onChange={e => inputProps.onChange(setOptionChecked(option, inputProps.value || [], e.target.checked))}
                />
                <label htmlFor={option.id}>{option.label}</label>
              </div>
            )}
          </>
        )}
      />
    </>
  );
}